import { configureStore } from "@reduxjs/toolkit";
import permissionsReducer from "./slices/permissionsSlice.js";
import roleReducer from "./slices/roleSlice.js";
import userReducer from "./slices/userSlice.js";
import platformRoleReducer from "./slices/platformRoleSlice.js";
import platformPermissionsReducer from "./slices/platformPermissionsSlice.js";
import isLoggedInReducer from "./slices/isLoggedInSlice.js";
import authLoadingReducer from "./slices/authLoadingSlice.js";

const store = configureStore({
    reducer: {
        authLoading: authLoadingReducer,
        isLoggedIn: isLoggedInReducer,
        role: roleReducer,
        user: userReducer,
        permissions: permissionsReducer,
        platformRole: platformRoleReducer,
        plaformPermissions: platformPermissionsReducer,
    },
});

export default store;